export const COLLAGE_IMAGES = [
  '/promotion-images/bg-1.png',
  '/promotion-images/bg-2.png',
  '/promotion-images/bg-3.png',
  '/promotion-images/bg-4.png',
  '/promotion-images/bg-5.jpg',
  '/promotion-images/bg-6.jpg',
];